/**
 * @generated SignedSource<<a5a6d0e82e428da960af0dc1a1abc4c4>>
 * @relayHash 273d979596298c8fcee11273951c160e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15aa4eecb798db8044ace93910ff132d0809c5a972721f5a601a3dc413a1716e

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePopularLabelStyle = "HEATMAP" | "LIST" | "%future added value";
export type usePopularLabelsDataQuery$variables = {
  cloudId: string;
  first?: number | null;
  spaceId?: string | null;
  style?: ConfluencePopularLabelStyle | null;
};
export type usePopularLabelsDataQuery$data = {
  readonly confluence_popularLabelsMacro: {
    readonly nodes: ReadonlyArray<{
      readonly count: number | null;
      readonly labelId: string | null;
      readonly name: string | null;
      readonly rank: number | null;
    } | null> | null;
  } | null;
};
export type usePopularLabelsDataQuery = {
  response: usePopularLabelsDataQuery$data;
  variables: usePopularLabelsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "style"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      },
      {
        "kind": "Variable",
        "name": "style",
        "variableName": "style"
      }
    ],
    "concreteType": "ConfluencePopularLabelEntryConnection",
    "kind": "LinkedField",
    "name": "confluence_popularLabelsMacro",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePopularLabelEntry",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "rank"
          },
          {
            "kind": "ScalarField",
            "name": "count"
          },
          {
            "kind": "ScalarField",
            "name": "labelId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePopularLabelsDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePopularLabelsDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "273d979596298c8fcee11273951c160e",
    "id": "15aa4eecb798db8044ace93910ff132d0809c5a972721f5a601a3dc413a1716e",
    "metadata": {},
    "name": "usePopularLabelsDataQuery",
    "operationKind": "query",
    "text": "query usePopularLabelsDataQuery($cloudId:ID!,$first:Int,$spaceId:ID,$style:ConfluencePopularLabelStyle){confluence_popularLabelsMacro(cloudId:$cloudId,first:$first,spaceId:$spaceId,style:$style){nodes{name,rank,count,labelId}}}"
  }
};
})();

(node as any).hash = "5b8aebb08be483a2b2f2f54bf875f423";

export default node;
